export default {
  currentDayDaterange(){
    return moment().format('DD/MM/YYYY')+" - "+moment().add(1,'days').format('DD/MM/YYYY');
  },
  currentMonthDaterange(){
    return moment().subtract(30,'days').format('DD/MM/YYYY')+" - "+moment().add(1,'days').format('DD/MM/YYYY');
  },
  currentYearDaterange(){
    return "01"+moment().subtract(395,'days').format('/MM/YYYY')+" - 01"+moment().add(1,'days').format('/MM/YYYY');
  },
  getCurrentDateTime() {
    return moment().format('DD/MM/YYYY HH:mm');
  },
  transformDateResponse(date){
    return moment(date, "DDMMYYYYHHmmss").format('DD/MM/YYYY HH:mm:ss');
  },
  correctDateTimeAPI(date_original){
    var date = moment(date_original, "DD/MM/YYYY HH:mm:ss");
    if(date.isDST()){
      return date.add(2,'hours').format('DD/MM/YYYY HH:mm:ss');
    }else{
      return date.add(1,'hours').format('DD/MM/YYYY HH:mm:ss');
    }
  },
  correctDateTimeRawAPI(date_original){
    var date = moment(date_original, "DDMMYYYYHHmmss");
    if(date.isDST()){
      return date.add(2,'hours').format('DDMMYYYYHHmmss');
    }else{
      return date.add(1,'hours').format('DDMMYYYYHHmmss');
    }
  },
  getmonthInYears(month_number){
    switch (month_number) {
      case 1:
        return 'Gener';
      case 2:
        return 'Febrer';
      case 3:
        return 'Març';
      case 4:
        return 'Abril';
      case 5:
        return 'Maig';
      case 6:
        return 'Juny';
      case 7:
        return 'Juliol';
      case 8:
        return 'Agost';
      case 9:
        return 'Setembre';
      case 10:
        return 'Octubre';
      case 11:
        return 'Novembre';
      case 12:
        return 'Desembre';
    }
  },
}



// WEBPACK FOOTER //
// ./src/utilities/dates_intervals.js